(function Index($, Adzuki)
{
	"use strict";

	var $modal           = $(".modal");
	var countProposalTab = 0;
	var countVendorTab   = 0;
	var countRejectedTab = 0;
	var hash;

	Adzuki.onload(['VendorCoop/index'], function onload() {
		$(document.body).on("click", "a[data-toggle='tab']", function tabToggle(event) {
			var href      = this.getAttribute("href");
			location.hash = href.replace('#', '') + '-tab';
		});

		$('.vendor-tabs').on('click', '.vendor-summary', function showVendorCoopSummary(e) {
			var vendor_coop_id    = $(this).data("id");
			var vendor_coop_title = $(this).data("title");

			e.preventDefault();

			$modal.find('.modal-title').text("Vendor Co-Op Summary - " + vendor_coop_title);
			$modal.find('.modal-body').html('<i class="fa fa-spinner fa-spin fa-2x"></i>&nbsp;Loading...');
			$modal.modal('show');

			Adzuki.Ajax.get('/VendorCoop/summary/' + vendor_coop_id + '/1')
			.then(function success(data) {
				$modal.find('.modal-body').html(data);
			});
		});

		$('body').on('ajax-pagination.loaded', function ajaxPagination() {
			Adzuki.Form.initAjaxForm('VendorCoopSort');
			Adzuki.Form.initAjaxForm('VendorCoopProposalSort');

			if ($('.table-selectable').length > 0) {
				Adzuki.ResponsiveTable($('.table-selectable'));
			}

			Adzuki.Form.initAjaxForm('CoopProposalStatus');
		});

		$('.nav-tabs>li').click(function changeTab() {
			$('.coop-tab-content').html('');

			if ($(this).data("type") === 'approved-coops' && countVendorTab < 1) {
				// countVendorTab += 1;

				$('#approved-coops-loader').removeClass('hidden');
				Adzuki.Ajax.get('/VendorCoop/vendorCoops/')
					.then(function populateVendorCoops(content) {
						$('#approved-coops-loader').addClass('hidden');
						$('#approved-coops-content').html(content);
						Adzuki.Form.initAjaxForm('VendorCoopSort');
					});
			} else if ($(this).data("type") === 'coop-proposals' && countProposalTab < 1) {
				// countProposalTab += 1;
				$('#coop-proposals-loader').removeClass('hidden');
				Adzuki.Ajax.get('/VendorCoop/manageCoopProposal/')
					.then(function populateCoopProposal(content) {
						$('#coop-proposals-loader').addClass('hidden');
						$('#coop-proposals-content').html(content);
						Adzuki.ResponsiveTable($('.table-selectable'));
						Adzuki.Form.initAjaxForm('VendorCoopProposalSort');
						Adzuki.Form.initAjaxForm('CoopProposalStatus');
				});
			} else if ($(this).data("type") === 'rejected-proposals' && countRejectedTab < 1) {
				$('#rejected-proposals-loader').removeClass('hidden');

				Adzuki.Ajax.get('/VendorCoop/rejectedProposals')
					.then(function populateRejectedProposals(content) {
						$('#rejected-proposals-loader').addClass('hidden');
						$('#rejected-proposals-content').html(content);
						Adzuki.ResponsiveTable($('.table-selectable'));
						Adzuki.Form.initAjaxForm('CoopProposalStatus');
					});
			}
		});

		if (location.hash) {
			hash = location.hash.replace('-tab', '');
			$("a[href='" + hash + "']").click();
		} else {
			$("a[href='#approved-coops']").click();
		}

		$('.vendor-tabs').on('change', '#vendorcoopsort-sort_by', function sortByChange() {
			var $form = $(this).closest('form');
			$form.submit();
		});
	});

	$(document).ready(function documentReady() {
		Adzuki.onload('VendorCoopAttachments/index/', function onload() {
			$('.task-details').off().on('click', _openTaskDetails);
		});

		Adzuki.onload(['VendorCoop/manageTasks'], function onload() {
			Adzuki.TaskManager.loadEntityTasks('vendor_coop');
		});
	});

	function _openTaskDetails(e)
	{
		var $anchor_elem = $(this);

		e.preventDefault();

		Adzuki.TaskManager.openTaskDetails($anchor_elem);
	}

}(jQuery, window.Adzuki || {}));
